import { AbstractControl, ValidatorFn } from '@angular/forms';
import _ from 'lodash';
import moment from 'moment';

export function DateRangeValidator(value: string, controlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let startDate;
    let endDate;
    let present: boolean = false;

    if (value) {
      let valueArray = value.replace(/ /g, '').split('|');
      if (valueArray.length > 0) {
        startDate = new Date(valueArray[0]);
        if (isNaN(startDate)) {
          return { dateRange: `${controlName} must have startDate` };
        }
        if (valueArray.length == 2) {
          if (valueArray[1].localeCompare('Present', 'en', { sensitivity: 'base' }) == 0) {
            present = true;
          } else {
            endDate = new Date(valueArray[1]);
            if (isNaN(endDate)) {
              return { dateRange: `${controlName} must have endDate if there is startDate` };
            }
          }
        }
        if (startDate && endDate && moment(startDate).isAfter(moment(endDate))) {
          return { dateRange: `${controlName} must have startDate before startDate` };
        } else if (!startDate && (present || endDate)) {
          return { dateRange: `${controlName} must have startDate` };
        } else if (startDate && !(present || endDate)) {
          return {
            dateRange: `${controlName} must have endDate or present checked if there is startDate`
          };
        }
      }
    }
    return null;
  };
}
